module.exports = __webpack_public_path__ + "img/block-768.b3a82c18.jpg";